import Link from "next/link";
import cls from "./Navigation.module.css";

export function NavigationTabs({ active }: { active: "editor" | "simulator" | "camera" }) {
    return <nav className={cls.labTabs} aria-label="Розділи Navigation Lab">
        <Link href="/labs/navigation" aria-current={active === "editor" ? "page" : undefined}>01 · Карта й розмітка</Link>
        <Link href="/labs/navigation/simulator" aria-current={active === "simulator" ? "page" : undefined}>02 · Симулятор локалізації</Link>
        <Link href="/labs/navigation/camera" aria-current={active === "camera" ? "page" : undefined}>03 · Камера й відео</Link>
    </nav>;
}
